import { IconButton as MuiIconButton } from '@mui/material'
import styled from 'styled-components'

interface ContainerProps {
  isCartView?: boolean
}

interface InfoProps {
  isMainInfo?: boolean
  highlight?: boolean
  isMandatoryPurchase?: boolean
}

type InfoWeight = 600 | 500 | 400

export const Container = styled.div<ContainerProps>`
  width: 100%;
  display: flex;
  gap: 10px;
`

export const HeaderContainer = styled.div<ContainerProps>`
  width: 100%;
  display: flex;
  gap: 10px;
`

export const TitleContainer = styled.div<ContainerProps>`
  gap: 5px;
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const BodyContainer = styled.div<ContainerProps>`
  display: flex;
  justify-content: flex-end;
`

export const AddonThumbnail = styled.img<ContainerProps>`
  width: 40px;
  height: 40px;
  min-width: 40px;
  object-fit: cover;
  border-radius: 4px;
`

export const AddonTitle = styled.p<InfoProps>`
  margin: 0;
  padding: 0;
  font-size: 12px;
  font-weight: 700;
  color: ${({ theme }) => theme?.colors?.textColor};

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`

export const AddonQuantity = styled.p<{ type: 'text' | 'number' }>`
  margin: 0;
  padding: 0;
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme?.colors?.textColor};

  & .addon-quantity {
    font-weight: 700;
  }
`

export const AddonInfo = styled.span<{ weight?: InfoWeight }>`
  font-size: 13px;
  font-weight: ${({ weight }) => (weight ? weight : 400)};
  color: ${({ theme }) => theme?.colors?.textColor};
`

export const AddonSubInfo = styled.span<{ light?: boolean }>`
  font-size: 12px;
  font-weight: 400;
  color: ${({ light, theme }) => (light ? theme?.colors?.gray5 : theme?.colors?.textColor)};
`

export const AddonPrice = styled.span`
  font-size: 13px;
  margin-top: 5px;
  font-weight: 700;
  text-align: right;
  color: ${({ theme }) => theme?.colors?.textColor};
`

export const IconButton = styled(MuiIconButton)`
  width: 24px;
  height: 24px !important;
  margin: 0 !important;
  padding: 0 !important;
  justify-content: flex-end !important;
`

export const PriceContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const AddonSection = styled.div`
  gap: 5;
  width: 100%;
  display: flex;
  flex-direction: column;
`
